export default (params) => {
  const { fieldData, fieldType } = params;
  const {
    document: { nodes: documentNodes },
  } = fieldData;

  const filteredAssociations = documentNodes.filter((_, index) => {
    return (
      documentNodes[index].type === 'associations_organization' ||
      documentNodes[index].type === 'projects_organization' ||
      documentNodes[index].type === 'volunteer_work_organization' ||
      documentNodes[index].type === 'leadership_organization'
    );
  });

  const associtaionNodes = filteredAssociations.map((association) => {
    const { nodes: associationNodes } = association;
    return associationNodes;
  });

  const filterAssociationRole = associtaionNodes.map((association) => {
    const { nodes: associationNodes } = association[1];
    return associationNodes;
  });

  function swap(arr, from, to) {
    arr.splice(from, 1, arr.splice(to, 1, arr[from])[0]);
  }

  filterAssociationRole.forEach((ass) => {
    return swap(ass, 1, 3);
  });
  filterAssociationRole.forEach((ass) => {
    return swap(ass, 1, 2);
  });

  const updatedAssociations = {
    ...fieldData,
    document: {
      ...fieldData.document,
      data: {
        ...fieldData.document.data,
        version: {
          number: 4,
          updated: true,
        },
      },
      nodes: documentNodes,
    },
  };

  return {
    [fieldType]: updatedAssociations,
  };
};
